import { useSelector } from 'react-redux';
import AgentStatus from 'routing-ui/agent-status/components/AgentStatus';
import { getUserId } from '../../selectors/userSelectors/getUserId';
import { getHasCapacityLimitsAccess } from '../selectors/getHasCapacityLimitsAccess';
import { useAtCapacityLimit } from 'conversations-inbox-lib/capacity-limits/public/hooks';
import { CONVERSATION_LIVE_CHAT } from 'conversations-inbox-lib/capacity-limits/public/constants';
import SetAgentStatusPrompt from '../components/SetAgentStatusPrompt';
import { getUsageTracker } from '../../usage-tracking/clients/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
export const AgentStatusContainer = () => {
  const agentId = useSelector(getUserId);
  const hasAccessToCapacityLimits = useSelector(getHasCapacityLimitsAccess);
  const {
    atCapacity
  } = useAtCapacityLimit({
    agentId,
    type: CONVERSATION_LIVE_CHAT,
    deferred: !hasAccessToCapacityLimits
  });
  return /*#__PURE__*/_jsx(AgentStatus, {
    agentId: agentId,
    atCapacity: atCapacity,
    Prompt: SetAgentStatusPrompt,
    usageTracker: getUsageTracker().tracker
  });
};
AgentStatusContainer.displayName = 'AgentStatusContainer';